import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-demo-persons-sidebar',
  templateUrl: './demo-persons-sidebar.component.html',
  styleUrls: ['./demo-persons-sidebar.component.less']
})
export class DemoPersonsSidebarComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
